"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Adds a tip to an Order
 * Can only be done when the order is in editable status
 * @param event of type UpdateTipEvent
 * @param prevState
 */
function default_1(event, prevState = {}) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if ((0, utils_1.isOrderEditable)(order.status)) {
        order.tip = (_a = event.amount) !== null && _a !== void 0 ? _a : 0;
    }
    return { ...order, ...(0, computePrice_1.computeOrderTotals)(order) };
}
exports.default = default_1;
//# sourceMappingURL=updateTip.js.map